<template>
  <div class="banner">
    <div v-if="showImage" class="banner__image">
      <slot name="image" />
    </div>
    <div class="banner__text">
      <EHeading as="h2" styled-as="h5" class="banner__headline">
        {{ headline }}
      </EHeading>
      <p v-safe-html="description" class="banner__description" />
    </div>
    <div v-if="showActions" class="banner__actions">
      <slot name="actions" />
    </div>
    <EButton
      v-if="hasCloseAction"
      icon="close"
      variant="bare"
      class="banner__close"
      data-test-id="close"
      @click.stop="onClose"
    />
  </div>
</template>

<script>
import EButton from '~~/common/vue/components/button';
import EHeading from '~~/common/vue/components/heading';

export default {
  name: 'EBanner',
  components: {
    EButton,
    EHeading,
  },
  props: {
    headline: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hasCloseAction: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showImage() {
      return !!this.$slots.image;
    },
    showActions() {
      return !!this.$slots.actions;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  @include elevation(2);

  display: flex;
  align-items: center;
  background: var(--color-background-primary);
  flex-wrap: wrap;
  padding: $space-l;
  width: 100%;

  @include desktop {
    padding: $space-m $space-3l;
  }
}

.banner__image {
  margin-right: $space-l;
  width: 50px;
}

.banner__text {
  display: contents;
  margin-top: $space-m;
  width: 100%;

  @include desktop {
    display: block;
    margin-top: 0;
    max-width: 50%;
    width: auto;
  }
}

.banner__headline {
  line-height: $line-height-l;
  margin: 0;

  @include desktop {
    font-size: $font-l;
  }
}

.banner__description {
  font-size: $font-m;
  margin-top: $space-s;
  margin-bottom: 0;
  width: 100%;

  @include desktop {
    margin-top: 0;
    width: auto;
  }
}

.banner__close {
  margin-left: auto;
}

.banner__actions {
  margin-top: $space-m;
  margin-left: auto;
  width: 100%;

  + .banner__close {
    margin-left: 0;
  }

  @include desktop {
    margin-top: 0;
    width: auto;
  }
}
</style>
